import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import Ticker from '@/pages/home/components/Ticker';
import HotFlow from '@/pages/home/components/HotFlow';
import Categories from '@/pages/home/components/Categories';
import Ranking from '@/pages/home/components/Ranking';
import TrustStats from '@/pages/home/components/TrustStats';
import Faq from '@/pages/home/components/Faq';
import SubscribeCta from '@/pages/home/components/SubscribeCta';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <HotFlow />
        <Categories />
        <Ranking />
        <TrustStats />
        <Faq />
        <SubscribeCta />
      </main>
      <Footer />
    </div>
  );
}